const calculateViewportUnits = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

const calculateHeaderSize = () => {
    const header = document.querySelector('.l-header')
    const headerMessages = document.querySelector('.js-header-messages')
    let height = 0;

    if (header) {
        height += parseInt(header.offsetHeight)
        document.documentElement.style.setProperty('--header-bar-height', `${parseInt(header.offsetHeight)}px`)
    }

    if (headerMessages) {
        height += parseInt(headerMessages.offsetHeight)
        document.documentElement.style.setProperty('--header-messages-height', `${parseInt(headerMessages.offsetHeight)}px`)
    }

    document.documentElement.style.setProperty('--header-height', `${height}px`)
}

export { calculateHeaderSize, calculateViewportUnits }
